import { PlusIcon, MinusIcon } from "components/Icons";
import { cn } from "tools/ui";

const iconStyle = "w-5 h-5 fill-current text-neutral-600";
const stBtn =
  "border-neutral-400 border-[1px] bg-neutral-200 active:shadow-lg active:scale-95 active:bg-blue-200 focus:outline-none rounded-full h-[25px] w-[46px] flex items-center justify-center";
const base =
  "rounded-none w-full text-center text-neutral-700 focus:outline-none focus:border focus:border-cyan-500";
const _color = "bg-neutral-100";

function IntegerCell(props) {
  const { field, data, onChange, readOnly, record } = props;

  if (!field.editable) {
    return data.value;
  }

  function onChangeInput(event) {
    let _value = event.target.value;
    _value = _value.toString().replace(/\./g, "");

    if (isNaN(_value)) return;

    if (_value === "" && props.min) {
      _value = props.min;
    } else if (props.min && parseInt(_value) < props.min) {
      _value = props.min;
    } else if (props.max && parseInt(_value) > props.max) {
      _value = props.max;
    }

    data.value = _value;
    onChange(field, data.value, record);
  }

  function onChangeValue(sign, e) {
    e.stopPropagation();
    if (sign === "+") {
      if (field.max && data.value + 1 > field.min) return;
      data.value = parseInt(data.value) + 1;
    } else if (data.value > 0) {
      if (field.min && parseInt(data.value) - 1 < field.min) return;
      data.value -= 1;
    }
    onChange(field, data.value, record);
  }

  return (
    <div className="flex h-9 w-full items-center max-w-[110px] mx-auto">
      {!readOnly && (
        <button className={cn(stBtn)} onClick={(e) => onChangeValue("-", e)}>
          <MinusIcon className={iconStyle} />
        </button>
      )}
      <input
        id={field.name}
        name={field.name}
        className={cn(
          base,
          _color,
          readOnly ? "max-w-20 !rounded-full" : "bg-transparent",
        )}
        type="text"
        onChange={onChangeInput}
        value={data.value}
        readOnly={readOnly}
      />
      {!readOnly && (
        <button onClick={(e) => onChangeValue("+", e)} className={cn(stBtn)}>
          <PlusIcon className={iconStyle} />
        </button>
      )}
    </div>
  );
}

export default IntegerCell;
